export class  blogComment{
    public IDrespuesta: number;
    public IDarticulo: number;
    public IDusuario = " ";
    public fecha:any;
    public texto= " ";
    public visible:boolean = true;
  }